<script lang="ts">
  type DiscountTagProps = {
    discount: string;
  };

  let { discount }: DiscountTagProps = $props();
</script>

<oc-tag-v1 class="discount-tag" size={"50"} variant="sale">
  {discount}
</oc-tag-v1>
